import { render, staticRenderFns } from "./contact_page.vue?vue&type=template&id=98c8d91c&scoped=true&"
import script from "./contact_page.vue?vue&type=script&lang=js&"
export * from "./contact_page.vue?vue&type=script&lang=js&"
import style0 from "./contact_page.vue?vue&type=style&index=0&id=98c8d91c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c8d91c",
  null
  
)

export default component.exports